/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { Menu, Button, Drawer, Collapse } from "antd";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useHookProjects } from "../../pages/Home/Store";
import { SolidProof_URL, BSCS_VERIFY } from "../constants/index";
import WagmiConnect from "../Wagmi-wallet";
import "./style.scss";


const iconLaunchPad = (
    <>
        <div className="box-icon-menu">
            <img src="/images/icon-ido.svg" alt="" />
        </div>
    </>
);
const iconLaunchPool = (
    <>
        <div className="box-icon-menu">
            <img src="/images/icon-launchpool.svg" alt="" />
        </div>
    </>
);
const iconApply = (
    <>
        <div className="box-icon-menu">
            <img src="/images/icon_apply.png" alt="" />
        </div>
    </>
);
const iconProgram = (
    <>
        <div className="box-icon-menu">
            <img src="/images/icon-program.png" alt="" />
        </div>
    </>
);
const iconMore = (
    <>
        <div className="box-icon-menu">
            <img src="/images/icon-more.svg" alt="" />
        </div>
    </>
);
const headerMore = (
    <>
        <div className="heeader-menu-collapse">
            <div className="box-icon">{iconMore}</div>
            <div className="title-menu">More</div>
        </div>
    </>
);
const headerBuyBSCS = (
    <>
        <div className="heeader-menu-collapse">
            <div className="title-menu bscs">
                Buy <span className="bscs-box">$BSCS</span>
            </div>
        </div>
    </>
);

const Header = () => {
    const [state, actions] = useHookProjects();

    useEffect(() => {
        // actions.getMarketInfo();
    }, []);

    const priceData = state.marketInfo.price;
    const bscsPriceUsd = priceData ? Number(priceData) : "0.00";
    const priceBSCS = Number(bscsPriceUsd).toFixed(3);
    useEffect(() => {
        actions.savePrice(priceBSCS);
    }, [priceBSCS]);

    const [visible, setVisible] = useState(false);

    const showDrawer = () => {
        setVisible(true);
    };

    const onCloseNew = () => {
        setVisible(false);
    };

    const onClose = () => {
        setVisible(false);
    };
    const { Panel } = Collapse;
    const onChange = (key) => {
        console.log(key);
    };

    const [scroll, setScroll] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 1);
        });
    }, []);

    const [scrollBg, setScrollBg] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScrollBg(window.scrollY > 1);
        });
    }, []);

    let location = useLocation();
    const pathLive = location.pathname.split("/");
    const pathLiveCenter = pathLive[1];

    const menuMobile = (
        <>
            <Collapse
                className="collapse-menu"
                accordion
                // defaultActiveKey={["0"]}
                expandIcon={({ isActive }) => (
                    <CaretRightOutlined rotate={isActive ? 90 : 0} />
                )}
                onChange={onChange}
            >
                {/* <Panel header={headerLaunchPad} key="1">
                    <ul className="sub-menu-collapse">
                        <Link 
                        to="/Ido" 
                        onClick={onCloseNew}
                        >
                            <div className="new-menu-item mobile">
                                <div className="new-text">
                                    <p className="new-description">
                                        Participate in early-stage token sales of promising
                                        blockchain projects.
                                    </p>
                                </div>
                            </div>
                        </Link>
                    </ul>
                </Panel> */}
                <Link className="defai" to="/Ido" onClick={onCloseNew}>
                    <img src="/images/icon-ido.svg" alt="" />
                    <span>IDO</span>
                </Link>
                <Link className="defai" to="/launch-pool" onClick={onCloseNew}>
                    <img src="/images/icon-launchpool.svg" alt="" />
                    <span>Launchpool</span>
                </Link>

                <Link className="defai" to="/apply-to-launch" onClick={onCloseNew}>
                    <img alt="" src="/images/icon_apply.png" />
                    <span>Apply To Launch</span>
                </Link>
                <a className="defai" href="/incubator-program" target="_blank">
                    <img alt="" src="/images/icon-program.png" />
                    <span>Incubator</span>
                </a>
                <Panel header={headerBuyBSCS} key="6">
                    <ul className="sub-menu-collapse">
                        <li>
                            <a
                                href="https://www.mexc.com/exchange/BSCS_USDT"
                                target={"_blank"}
                            >
                                <span className="icon-menu-prefix mobile">
                                    <img alt="" src="/images/mexc.png" />{" "}
                                </span>{" "}
                                Mexc
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://pancakeswap.finance/?inputCurrency=BNB&outputCurrency=0xbcb24AFb019BE7E93EA9C43B7E22Bb55D5B7f45D"
                                target={"_blank"}
                            >
                                <span className="icon-menu-prefix mobile">
                                    <img alt="" src="/images/pancake.png" />{" "}
                                </span>{" "}
                                PancakeSwap
                            </a>
                        </li>
                        <li>
                            <a href="https://www.gate.io/trade/BSCS_USDT" target={"_blank"}>
                                <span className="icon-menu-prefix mobile">
                                    <img alt="" src="/images/gate.png" />{" "}
                                </span>{" "}
                                Gate
                            </a>
                        </li>
                    </ul>
                </Panel>

                <Panel header={headerMore} key="9">
                    <ul className="sub-menu-collapse">
                        <li>
                            <a href="https://github.com/BSCStationSwap" target={"_blank"}>
                                Github
                            </a>
                        </li>
                        <li>
                            <a href="https://docs.bscs.finance/" target={"_blank"}>
                                Docs
                            </a>
                        </li>
                        <li>
                            <a href="https://bscs.substack.com/" target={"_blank"}>
                                Blog
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://skynet.certik.com/projects/bscs"
                                target={"_blank"}
                            >
                                Certik Audit
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://github.com/peckshield/publications/blob/master/audit_reports/PeckShield-Audit-Report-BSCStationStartPools-v1.0.pdf"
                                target={"_blank"}
                            >
                                PeckShield Audit
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://github.com/Quillhash/QuillAudit_Reports/blob/master/BSCS%20Smart%20Contract%20Audit%20Report%20-%20QuillAudits.pdf"
                                target={"_blank"}
                            >
                                Quillhash Audit
                            </a>
                        </li>
                        <li>
                            <a href={`${SolidProof_URL}`} target="_blank" rel="noreferrer">
                                SolidProof
                            </a>
                        </li>
                        <li>
                            <a href={`${BSCS_VERIFY}`} target="_blank" rel="noreferrer">
                                BSCS Verify
                            </a>
                        </li>

                    </ul>
                </Panel>
            </Collapse>
        </>
    );

    const headerMobileDrawer = (
        <>
            <div className="main-logo-mobile-row">
                <div className="box-img">
                    <Link to={"/"}>
                        <img src="/images/logo-brand-v3.svg" alt="" />
                    </Link>
                </div>
            </div>
        </>
    );



    const menuHeader = (
        <>
            <Menu mode="horizontal" style={{ minWidth: "870px" }}>
                <Menu.Item style={{ minWidth: '100px' }} key="1" icon={iconLaunchPad}>
                    <Link to="/Ido">IDO</Link>
                </Menu.Item>

                <Menu.Item style={{ minWidth: '163px' }} key="2" icon={iconLaunchPool}>
                    <Link to="/launch-pool">Launchpool</Link>
                </Menu.Item>

                <Menu.Item style={{ minWidth: '201px' }} key="3" icon={iconApply}>
                    <Link to="/apply-to-launch">Apply To Launch</Link>
                </Menu.Item>
                <Menu.Item style={{ minWidth: '150px' }} key="4" icon={iconProgram}>
                    <Link to="/incubator-program">Incubator</Link>
                </Menu.Item>
                <Menu.SubMenu
                    style={{ minWidth: '157px' }}
                    key="SubMenu6"
                    title={
                        <>
                            Buy <span className="bscs-box">$BSCS</span>
                        </>
                    }
                >
                    <Menu.Item key="10">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <span className="icon-menu-prefix">
                                    <img alt="" src="/images/mexc.png" />{" "}
                                </span>
                                <a
                                    href="https://www.mexc.com/exchange/BSCS_USDT"
                                    target={"_blank"}
                                >
                                    Mexc
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="151">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <span className="icon-menu-prefix">
                                    <img alt="" src="/images/pancake.png" />{" "}
                                </span>
                                <a
                                    href="https://pancakeswap.finance/?inputCurrency=BNB&outputCurrency=0xbcb24AFb019BE7E93EA9C43B7E22Bb55D5B7f45D"
                                    target={"_blank"}
                                >
                                    PancakeSwap
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="152">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <span className="icon-menu-prefix">
                                    <img alt="" src="/images/gate.png" />{" "}
                                </span>
                                <a href="https://www.gate.io/trade/BSCS_USDT" target={"_blank"}>
                                    Gate
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu key="SubMenu7" icon={iconMore}>
                    <Menu.Item key="15">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a href="https://github.com/BSCSGlobal" target={"_blank"}>
                                    Github
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="20">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a href="https://docs.bscs.finance/" target={"_blank"}>
                                    Docs
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="21">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a href="https://bscstation.substack.com/" target={"_blank"}>
                                    Blog
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="22">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a
                                    href="https://skynet.certik.com/projects/bscs"
                                    target={"_blank"}
                                >
                                    Certik Audit
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="23">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a
                                    href="https://github.com/peckshield/publications/blob/master/audit_reports/PeckShield-Audit-Report-BSCStationStartPools-v1.0.pdf"
                                    target={"_blank"}
                                >
                                    PeckShield Audit
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="24">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a
                                    href="https://www.quillaudits.com/smart-contract-audit"
                                    target={"_blank"}
                                >
                                    QuillAudits
                                </a>
                            </span>
                            <span className="iconMenu">
                                {" "}
                                <img src="/images/arrow-right.svg" alt="" />
                            </span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="25">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a href={`${SolidProof_URL}`} target="_blank" rel="noreferrer">
                                    SolidProof
                                </a>
                            </span>
                            <span className="iconMenu"></span>
                        </div>
                    </Menu.Item>
                    <Menu.Item key="99">
                        <div className="ti-menu">
                            <span className="textMenu">
                                <a href={`${BSCS_VERIFY}`} target="_blank" rel="noreferrer">
                                    BSCS Verify
                                </a>
                            </span>
                            <span className="iconMenu"></span>
                        </div>
                    </Menu.Item>

                </Menu.SubMenu>
            </Menu>
        </>
    );


    //   if (isMobile) {
    //         return (
    //             <>
    //                 <div
    //                     className={
    //                         scroll ? "main-header-mobile scroll" : "main-header-mobile"
    //                     }
    //                 >
    //                     <div className="main-logo-mobile">
    //                         <div className="box-img">
    //                             <Link to={"/"}>
    //                                 <img src="/images/logo-brand-v3.svg" alt="" />
    //                             </Link>
    //                         </div>
    //                     </div>

    //                     <div className="main-cnt-mobile">
    //                         <WagmiConnect />
    //                     </div>
    //                     <div className="wrap-header-right">
    //                         <div className="main-menu-mobile">
    //                             <div className="drawer-menu">
    //                                 <Button type="primary" className="btn-open" onClick={showDrawer}>
    //                                     <img src="/images/open-menu.png" alt="" />
    //                                 </Button>
    //                                 <Drawer
    //                                     title={headerMobileDrawer}
    //                                     className="drawer-mobile"
    //                                     placement="right"
    //                                     onClose={onClose}
    //                                     visible={visible}
    //                                     destroyOnClose={true}
    //                                 >
    //                                     {menuMobile}
    //                                     <div className="footer-menu-mobile">
    //                                         <div className="content-ft-menu">
    //                                             <ul className="list-menu-ft">
    //                                                 <li>
    //                                                     <a
    //                                                         href="https://x.com/bscstation"
    //                                                         target="_blank"
    //                                                         rel="noreferrer"
    //                                                     >
    //                                                         <img src="/images/twi.svg?v=2" alt="" />
    //                                                     </a>
    //                                                 </li>
    //                                                 <li>
    //                                                     <a
    //                                                         href="https://bscs.substack.com/"
    //                                                         target="_blank"
    //                                                         rel="noreferrer"
    //                                                     >
    //                                                         <img src="/images/substack.png" alt="" />
    //                                                     </a>
    //                                                 </li>

    //                                                 <li>
    //                                                     <a
    //                                                         href="https://t.me/bscstation_media"
    //                                                         target="_blank"
    //                                                         rel="noreferrer"
    //                                                     >
    //                                                         <img src="/images/tele.svg" alt="" />
    //                                                     </a>
    //                                                 </li>
    //                                                 <li>
    //                                                     <a
    //                                                         href="https://www.facebook.com/BSCStation"
    //                                                         target="_blank"
    //                                                         rel="noreferrer"
    //                                                     >
    //                                                         <img src="/images/face-v3.png" alt="" />
    //                                                     </a>
    //                                                 </li>
    //                                                 <li>
    //                                                     <a
    //                                                         href="https://www.youtube.com/c/BSCStationOfficial"
    //                                                         target="_blank"
    //                                                         rel="noreferrer"
    //                                                     >
    //                                                         <img src="/images/you.svg" alt="" />
    //                                                     </a>
    //                                                 </li>
    //                                             </ul>
    //                                         </div>
    //                                         <div className="price-ft mobile">
    //                                             <div className="price-l">
    //                                                 <div className="img-price-ft">
    //                                                     <a
    //                                                         href="https://bscscan.com/token/0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d"
    //                                                         target="_blank"
    //                                                     >
    //                                                         <img src="/images/icon-price.png" alt="" />{" "}
    //                                                     </a>
    //                                                 </div>
    //                                                 <span>${priceBSCS}</span>
    //                                             </div>
    //                                             <div className="price-r ">
    //                                                 <div className="icon-meta">
    //                                                     <img src="/images/icon-meta.png" alt="" />
    //                                                 </div>
    //                                                 <button type="button" className="btn-buy-bscs">
    //                                                     Buy BSCS
    //                                                 </button>
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </Drawer>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </>
    //         );
    //     }

    const [check, setCheck] = useState(false)


    useEffect(() => {
        const handleResize = () => {
            window?.innerWidth > 1442 ? (setCheck(false)) : setCheck(true)
        };

        window.addEventListener('resize', handleResize);

        // Cleanup khi component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, [check]);





    return (
        <>
            {window?.innerWidth < 1442 ? (
                <div
                    className={
                        scroll ? "main-header-mobile scroll" : "main-header-mobile"
                    }
                >
                    <div className="main-logo-mobile">
                        <div className="box-img">
                            <Link to={"/"}>
                                <img src="/images/logo-brand-v3.svg" alt="" />
                            </Link>
                        </div>
                    </div>
                    <div className="wrap-header-right">
                        <div className="main-cnt-mobile">
                            <WagmiConnect />
                        </div>
                        <div className="main-menu-mobile">
                            <div className="drawer-menu">
                                <Button type="primary" className="btn-open" onClick={showDrawer}>
                                    <img src="/images/open-menu.png" alt="" />
                                </Button>
                                <Drawer
                                    title={headerMobileDrawer}
                                    className="drawer-mobile"
                                    placement="right"
                                    onClose={onClose}
                                    visible={visible}
                                    destroyOnClose={true}
                                >
                                    {menuMobile}
                                    <div className="footer-menu-mobile">
                                        <div className="content-ft-menu">
                                            <ul className="list-menu-ft">
                                                <li>
                                                    <a
                                                        href="https://x.com/bscstation"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src="/images/twi.svg?v=2" alt="" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="https://bscs.substack.com/"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src="/images/substack.png" alt="" />
                                                    </a>
                                                </li>

                                                <li>
                                                    <a
                                                        href="https://t.me/bscstation_media"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src="/images/tele.svg" alt="" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="https://www.facebook.com/BSCStation"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src="/images/face-v3.png" alt="" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="https://www.youtube.com/c/BSCStationOfficial"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src="/images/you.svg" alt="" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="price-ft mobile">
                                            <div className="price-l">
                                                <div className="img-price-ft">
                                                    <a
                                                        href="https://bscscan.com/token/0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d"
                                                        target="_blank"
                                                    >
                                                        <img src="/images/icon-price.png" alt="" />{" "}
                                                    </a>
                                                </div>
                                                <span>${priceBSCS}</span>
                                            </div>
                                            <div className="price-r ">
                                                <div className="icon-meta">
                                                    <img src="/images/icon-meta.png" alt="" />
                                                </div>
                                                <button type="button" className="btn-buy-bscs">
                                                    Buy BSCS
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Drawer>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="wrap-header">
                    <header className={scroll ? "main-header scroll" : "main-header"}>
                        <div className="main-guide">
                            <div className="main-logo">
                                <div className="box-img">
                                    <Link to={"/"}>
                                        <img src="/images/logo-brand-v3.svg" alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="main-menu">{menuHeader}</div>
                        </div>
                        <div className="main-connect">
                            <div className="cnt-right">
                                <WagmiConnect />
                            </div>
                        </div>
                    </header>
                </div>
            )}



        </>
    );
};

export default Header;
